import { render } from "./IonExplosionButton.vue?vue&type=template&id=9f17856c&scoped=true&ts=true"
import script from "./IonExplosionButton.vue?vue&type=script&lang=ts"
export * from "./IonExplosionButton.vue?vue&type=script&lang=ts"

import "./IonExplosionButton.vue?vue&type=style&index=0&id=9f17856c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f17856c"]])

export default __exports__